import { render, staticRenderFns } from "./BirIsinYapilmasiVeyaYapilmamasiAlacakForm.vue?vue&type=template&id=41145e6c"
import script from "./BirIsinYapilmasiVeyaYapilmamasiAlacakForm.vue?vue&type=script&lang=ts"
export * from "./BirIsinYapilmasiVeyaYapilmamasiAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports